import React from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { Link, Outlet } from "react-router-dom";

function AdminDashboard() {
  return (
    <>
      {/* Top Navbar */}
      <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
          <Navbar.Brand>Uiplus Admin</Navbar.Brand>

          <Navbar.Toggle />
          <Navbar.Collapse>
            <Nav className="me-auto">

              <Nav.Link as={Link} to="/admin">
                Dashboard
              </Nav.Link>

              <Nav.Link as={Link} to="/admin/add-blog">
                Add Blog
              </Nav.Link>

              <Nav.Link as={Link} to="/admin/blogs">
                Manage Blogs
              </Nav.Link>
              <Nav.Link as={Link} to="/admin/request">
                Demo Request
              </Nav.Link>

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Page Content */}
      <Container className="py-4">
        <Outlet />
      </Container>
    </>
  );
}

export default AdminDashboard;